import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StudentState {
  selectedStudentId: string | null;
  filterGrade: string | null;
  filterSection: string | null;
}

const initialState: StudentState = {
  selectedStudentId: null,
  filterGrade: null,
  filterSection: null,
};

const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    setSelectedStudent(state, action: PayloadAction<string | null>) {
      state.selectedStudentId = action.payload;
    },
    setStudentFilters(state, action: PayloadAction<{ grade?: string | null; section?: string | null }>) {
      if (action.payload.grade !== undefined) state.filterGrade = action.payload.grade;
      if (action.payload.section !== undefined) state.filterSection = action.payload.section;
    },
    clearStudentFilters(state) {
      state.filterGrade = null;
      state.filterSection = null;
    },
  },
});

export const { setSelectedStudent, setStudentFilters, clearStudentFilters } = studentSlice.actions;
export default studentSlice.reducer;